export const visit = (vm, at) => {
at({ "en": { "composer-ui": { "alerts": { "mismatched-default-team-sender": { "message": "Your default from email address is not currently applied" } } } } });
};